import { DashboardResponse } from "@practium/features/api";
import { DashboardConfig } from "@practium/features/dashboard";
import { FileCheckIcon, SuppliesIcon, UsersIcon } from "@practium/ui";
import { consultantActivityLineConfig, consultantAnalysisTypeDonutConfig, consultantFarmersChartConfig, consultantRecommendationsChartConfig, consultantTopFarmersConfig } from "./consultantCharts.config";
import { getConsultantChartsData } from "./mappers";



export const getConsultantDashboardConfig = (data?: DashboardResponse): DashboardConfig => {
    const {
        monthlyChartData,
        topFarmersData,
        doughnutData,
        pieData,
        lineChartData,
    } = getConsultantChartsData(data);

    return {
        stats: [
            {
                id: 'agricultores',
                label: data?.cards[0].title || 'Agricultores Atendidos',
                value: data?.cards[0].value || null,
                trendValue: data?.cards[0].variationPercent || null,
                trendLabel: 'novos este mês',
                trendDirection: (data?.cards?.[0]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <UsersIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'analises',
                label: 'Análises Processadas',
                value: data?.cards[1].value || null,
                trendValue: data?.cards[1].variationPercent || null,
                trendLabel: 'este mês',
                trendDirection: (data?.cards?.[1]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <SuppliesIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'recomendacoes',
                label: 'Recomendações Geradas',
                value: data?.cards[2].value || null,
                trendValue: data?.cards[2].variationPercent || null,
                trendLabel: 'vs mês anterior',
                trendDirection: (data?.cards?.[2]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <FileCheckIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
        ],
        promotion: {
            title: 'Adicione novos\nagricultores',
            subtitle: 'Vincule novos agricultores e\nexpanda seu atendimento',
            buttonText: 'Adicionar Agricultor',
            onButtonClick: '/usuarios/novo?type=farmers',
        },
        slots: [
            {
                type: 'comparisonBar',
                size: 'twoThirds',
                config: {
                    ...consultantFarmersChartConfig,
                    mainValue: data?.monthlyChart?.title,
                    footerText: data?.monthlyChart?.subtitle,
                    trendValue: `${data?.monthlyChart?.growthPercentage}%`,
                    trendDirection: (data?.monthlyChart?.growthPercentage ?? 0) > 0 ? 'up' : 'down',
                },
                data: monthlyChartData,
            },
            {
                type: 'donut',
                size: 'oneThird',
                config: consultantAnalysisTypeDonutConfig,
                data: doughnutData,
            },
            {
                type: 'pie',
                size: 'oneThird',
                config: consultantRecommendationsChartConfig,
                data: pieData,
            },
            {
                type: 'metricList',
                size: 'oneThird',
                config: consultantTopFarmersConfig,
                data: topFarmersData,
            },
            {
                type: 'comparisonLine',
                size: 'oneThird',
                config: {
                    ...consultantActivityLineConfig,
                    mainValue: data?.lineCharts[0]?.subtitle,
                    trendValue: `${data?.lineCharts[0]?.growthPercentage}%`,
                    footerText: data?.lineCharts[0]?.period
                },
                data: lineChartData,
            },
        ]

    }

}
